<template>
  <div>
    <Row>
      <i-col span="24">
        <Form :model="searchForm" ref="searchForm" inline :label-width="60">
        <FormItem label="主机名">
          <Input v-model="searchForm.hostname" style="min-width: 100px" />
        </FormItem>
        <FormItem label="私有IP">
          <Input v-model="searchForm.inner_ip" style="min-width: 100px" />
        </FormItem>
        <FormItem label="公网IP">
          <Input v-model="searchForm.public_ip" style="min-width: 100px" />
        </FormItem>
        <FormItem label="操作系统">
          <Select v-model="searchForm.os" style="min-width:100px" disabled>
            <Option v-for="item in osList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem :label-width="0" class="mob-align-right">
          <Button type="primary" @click="getServers">搜索</Button>
          <!-- <Button type="primary">搜索</Button>
          <Button style="margin-left: 8px" @click="searchReset">重置</Button> -->
        </FormItem>
      </Form>
      </i-col>
      </Row>
      <Row>
        <Table
          ref="selection"
          size="small"
          height="400"
          @on-selection-change="selectChange"
          :columns="columns"
          :data="tableData"
          :loading="table_loading"
        ></Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div>
            <span style="float: left;">已选择 {{ countSel }} 条</span>
            <span style="float: right;">共 {{ count }} 条</span>
          </div>
        </div>
      </Row>
  </div>
</template>
<script>
import Tables from '_c/tables'
import { getOpsCenterSelAllServer } from '@/api/opscenter'
import { getBaseMonitorOne } from '@/api/monitor'
export default {
  name: 'ServerSelList',
  props: {
    rdOperateSel: String,
    latestWinVersion: String,
    latestLinuxVersion: String
  },
  components: {
    Tables
  },
  data () {
    return {
      osList: [
        {
          value: 0,
          label: 'Linux'
        },
        {
          value: 1,
          label: 'Windows'
        }
      ],
      count: 0,
      countSel: 0,
      size: 10,
      page: 1,
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          minWidth: 100,
          title: '主机名',
          tooltip: true,
          key: 'hostname',
          align: 'center'
        },
        {
          minWidth: 100,
          title: '操作系统',
          align: 'center',
          key: 'os',
          render: (h, params) => {
            let k = { 0: 'Linux', 1: 'Windows' }
            if (params.row.os === 0 || params.row.os === 1) {
              return h('div', k[params.row.os])
            } else {
              return ''
            }
          }
        },
        {
          minWidth: 130,
          title: '私有IP',
          align: 'center',
          key: 'inner_ip'
        },
        {
          minWidth: 130,
          title: '公网IP',
          align: 'center',
          key: 'public_ip'
        },
        {
          minWidth: 120,
          title: 'Agent状态',
          align: 'center',
          key: 'status',
          render: (h, params) => {
            const row = params.row
            const color = row.status === 0 ? 'error' : row.status === 1 ? 'success' : 'warning'
            const text = row.status === 0 ? '断开' : row.status === 1 ? '运行' : '未知'
            // 未安装， 正常， 异常
            return h('Tag', {
              props: {
                type: 'dot',
                color: color
              }
            }, text)
          }
        }
      ],
      tableData: [],
      tableDataSel: [],
      table_loading: false,
      searchForm: {
        hostname: '',
        inner_ip: '',
        public_ip: '',
        os: ''
      }
    }
  },
  watch: {
    latestWinVersion () {
      this.getServers()
    },
    latestLinuxVersion () {
      this.getServers()
    },
    rdOperateSel () {
      this.getServers()
    }
  },
  methods: {
    selectChange (selection) {
      this.tableDataSel = selection
      this.countSel = this.tableDataSel.length
      this.$emit('on-result-change', this.tableDataSel)
    },
    getServers (value = 1) {
      this.page = value
      this.table_loading = true
      // this.searchForm['size'] = this.size
      // this.searchForm['page'] = this.page
      getOpsCenterSelAllServer(this.searchForm).then(res => {
        let result = res.data
        let tableData = result
        this.count = result.length
        let hostnames = []
        for (let i in result) {
          if (result[i].hostname) {
            hostnames.push(result[i].hostname)
          }
        }
        let reqParams = {
          'hostnames': hostnames,
          'counters': ['mem.memused.percent', 'cpu.user', 'df.statistics.used.percent', 'agent.alive']
        }
        getBaseMonitorOne(reqParams).then(monitorRes => {
          let MonitorDataResult = monitorRes.data
          if (MonitorDataResult.code === 200) {
            for (let l in tableData) {
              let hostname = tableData[l].hostname
              let cpuUsage = ''
              let memoryUsage = ''
              let diskUsage = ''
              let agentAlive = 0
              let timestamp = ''
              if (hostname) {
                if (MonitorDataResult.data[hostname]['timestamp']) {
                  cpuUsage = MonitorDataResult.data[hostname]['cpu.user']
                  memoryUsage = MonitorDataResult.data[hostname]['mem.memused.percent']
                  diskUsage = MonitorDataResult.data[hostname]['df.statistics.used.percent']
                  agentAlive = MonitorDataResult.data[hostname]['agent.alive']
                  timestamp = MonitorDataResult.data[hostname]['timestamp']
                }
              }
              tableData[l]['status'] = agentAlive
              tableData[l]['cpu_usage'] = cpuUsage
              tableData[l]['memory_usage'] = memoryUsage
              tableData[l]['disk_usage'] = diskUsage
              tableData[l]['timestamp'] = timestamp
            }
          } else {
            this.$Notice.error({
              title: '获取监控数据失败！',
              desc: MonitorDataResult.msg
            })
          }
          // console.log(this.rdOperateSel)
          // console.log(this.latestWinVersion)
          // console.log(this.latestLinuxVersion)
          if (this.rdOperateSel === 'install') {
            this.tableData = tableData.filter(item => item.status !== 1)
          } else if (this.rdOperateSel === 'update') {
            this.tableData = tableData.filter(item => {
              // console.log(item.status === 1 && item.os === 1 && item.agent_version !== this.latestWinVersion) || (item.status === 1 && item.os === 0 && item.agent_version !== this.latestLinuxVersion)
              return (item.status === 1 && item.os === 1 && item.agent_version !== this.latestWinVersion) || (item.status === 1 && item.os === 0 && item.agent_version !== this.latestLinuxVersion)
            })
          } else if (this.rdOperateSel === 'uninstall') {
            this.tableData = tableData.filter(item => item.status === 1)
          }
          this.count = this.tableData.length
          this.table_loading = false
        }).catch(res => {
          this.tableData = tableData
          this.table_loading = false
          if (res.request) {
            this.$Notice.error({
              title: '获取监控数据失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          }
        })
      })
    },
    searchReset () {
      this.searchForm.hostname = ''
      this.searchForm.inner_ip = ''
      this.searchForm.public_ip = ''
      this.searchForm.os = ''
    },
    handleUpdate () {
    },
    handleInstall () {
    },
    handleDelete () {
    }
  },
  created: function () {
    // console.log(this.latestWinVersion + 'create version')
    // console.log(this.rdOperateSel + 'create rdOperateSel')
  },
  mounted: function () {
    this.getServers()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
